import React from 'react';

export default () => {
  return <div>비급여 관리</div>;
};
